import { router, useLocalSearchParams, useNavigation } from 'expo-router';
import { useEffect, useLayoutEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import GoBackButton from '@/components/buttons/GoBackButton';
import DirectorForm from '@/components/forms/DirectorForm';
import FormWrapper from '@/components/forms/FormWrapper';
import Title from '@/components/Title';
import { DirectorData } from '@/lib/validations/NpoOnboardingSchema';
import { i18n } from '@/utils/i18n';
import { safeJsonParse } from '@/utils/jsonParse';

const AddUpdateDirector = () => {
  const navigation = useNavigation<any>();
  const { directorDataJson, directorIndex } = useLocalSearchParams<{
    directorDataJson: string;
    directorIndex: string;
  }>();
  const [initialDirectorData, setInitialDirectorData] = useState<DirectorData | undefined>(undefined);

  useLayoutEffect(() => {
    navigation.setOptions({
      headerShown: true,
      headerTransparent: true,
      headerTitle: () => <Title label={i18n.t('sign_in.nonProfit.board_directors.add_title')} />,
      headerLeft: () => <GoBackButton navigateTo={'/login/nonProfit/onBoarding/boardDirectors'} />,
      headerBackVisible: false
    });
  }, [navigation]);

  useEffect(() => {
    if (directorDataJson) {
      const parsedDirector = safeJsonParse<DirectorData>(directorDataJson);
      if (parsedDirector) setInitialDirectorData(parsedDirector);
    }
  }, [directorDataJson]);

  return (
    <SafeAreaView style={styles.content}>
      <FormWrapper keyboardVerticalOffset={0} scrollEnable={false}>
        <View style={styles.container}>
          <DirectorForm
            initialData={initialDirectorData}
            showDoneButton
            onDone={(data) => {
              router.dismissTo({
                pathname: '/(app)/login/nonProfit/onBoarding/boardDirectors',
                params: {
                  directorDataJson: JSON.stringify(data),
                  directorIndex: directorIndex
                }
              });
            }}
          />
        </View>
      </FormWrapper>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  content: {
    flex: 1
  },

  container: {
    flex: 1,
    marginTop: 60
  }
});

export default AddUpdateDirector;
